import React, { useState } from "react";
import { X, Save } from "lucide-react";
import { supabase } from "../../Services/supabaseClient";
import { useCompany } from "../../context/CompanyContext";
import "../Accounting/FixedAssets/fixedAssets.css";

export default function WarehouseFormModal({ warehouse, onClose, onSaved }) {
  const { companyId } = useCompany();
  const isEdit = Boolean(warehouse?.id);

  const [name, setName] = useState(warehouse?.name || "");
  const [makeDefault, setMakeDefault] = useState(
    Boolean(warehouse?.is_default)
  );
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function save() {
    setErr("");
    if (!companyId) return;
    if (!name.trim()) {
      setErr("Name is required.");
      return;
    }

    setBusy(true);
    try {
      if (makeDefault) {
        // unset old default first (safe)
        const { error: e1 } = await supabase
          .from("warehouses")
          .update({ is_default: false })
          .eq("company_id", companyId);
        if (e1) throw e1;
      }

      if (isEdit) {
        const { error } = await supabase
          .from("warehouses")
          .update({ name: name.trim(), is_default: makeDefault })
          .eq("company_id", companyId)
          .eq("id", warehouse.id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from("warehouses")
          .insert({
            company_id: companyId,
            name: name.trim(),
            is_default: makeDefault,
          });
        if (error) throw error;
      }

      onSaved?.();
    } catch (e) {
      setErr(e.message || "Failed to save.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 14,
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        className="fa-panel"
        style={{ width: "min(720px, 100%)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
        >
          <div>
            <div style={{ fontSize: 18, fontWeight: 900 }}>
              {isEdit ? "Edit Warehouse" : "Add Warehouse"}
            </div>
            <div style={{ opacity: 0.8, fontSize: 13, marginTop: 4 }}>
              Use warehouses to track stock per location and enable transfers.
            </div>
          </div>
          <button className="fa-icon-btn" onClick={onClose} title="Close">
            <X size={16} />
          </button>
        </div>

        <div className="fa-toolbar" style={{ marginTop: 12 }}>
          <input
            className="fa-input"
            placeholder="Warehouse name (e.g., Main Warehouse)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={busy}
          />
          <label
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              fontSize: 13,
              opacity: 0.9,
            }}
          >
            <input
              type="checkbox"
              checked={makeDefault}
              onChange={(e) => setMakeDefault(e.target.checked)}
              disabled={busy}
            />
            Set as default
          </label>
        </div>

        {err && (
          <div style={{ marginTop: 10, color: "#ffb4b4", fontSize: 13 }}>
            {err}
          </div>
        )}

        <div
          className="fa-actions"
          style={{ marginTop: 12, justifyContent: "flex-end" }}
        >
          <button className="fa-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            className="fa-btn fa-btn-primary"
            onClick={save}
            disabled={busy}
          >
            <Save size={16} /> {busy ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
